import "./App.css";

const Info = () => (
  <>
    <div className="info-container" id="info">
      <h1>info</h1>
      <img src="./bb-room.jpg" alt="image of the people in broke bldgs" />
      <div className="info-copy">
        <p>
          <strong>BROKE BLDGS</strong> is a collaboration between musician Rick
          Mitchell and visual artist Lauren Medsker. They both came of age in
          Philadelphia’s punk/screamo/indie/D.I.Y. scene, with Mitchell playing
          in countless bands, including{" "}
          <a
            href="https://open.spotify.com/artist/74u9Y0Bjhmm11EMvzPgAET"
            target="_blank"
          >
            SPRCSS
          </a>{" "}
          and{" "}
          <a
            href="https://open.spotify.com/artist/1is5Ln2yLfevgVKys8Broy"
            target="_blank"
          >
            The YMD
          </a>
          . (He also currently plays bass with{" "}
          <a
            href="https://open.spotify.com/artist/6cMBAd7j8KLD9TnjfwQ91E"
            target="_blank"
          >
            Amanda Blank
          </a>{" "}
          and creates instrumental music as{" "}
          <a
            href="https://open.spotify.com/artist/6bOAy2iO4mrAPh1wukpCrM"
            target="_blank"
          >
            12 Letter Alphabet
          </a>
          ).{" "}
        </p>
        <p>
          Having spent thousands of hours listening to music together, Medsker
          and Mitchell decided to create their own. Their debut album{" "}
          <i>Resurrect Dead</i> — named after Philadelphia’s mysterious{" "}
          <a href="https://en.wikipedia.org/wiki/Toynbee_tiles" target="_blank">
            Toynbee tiles
          </a>{" "}
          — pulls various elements from their record collection, drawing from
          electro, post-punk and minimalism. The music both honors and
          reinterprets the couple’s influences over the years – from GSL to ZYX
          Music, from the circuitry of a Moog to the propulsion of Brazilian
          hand drums.
        </p>
        <p>
          The vocals are blurry, distorted, fucked-with. The synthesizers dark,
          dizzying. The percussion somewhere between a party and a gut punch.
          The album embodies the anger of the moment we’re living through and
          the estrangement that comes when the world shuts down. But it also
          reflects the hope of rebirth — resurrecting what was once thought dead
          and building up from what was broken.{" "}
        </p>
        <p>
          <i>Resurrect Dead</i> was written, recorded and produced by{" "}
          <strong>BROKE BLDGS</strong> with additional production, mixing and
          mastering by Matt Coogan (
          <a href="https://www.oneera.net/" target="_blank">
            One Era
          </a>
          , FSQ).{" "}
        </p>
        <p>
          <strong>BROKE BLDGS</strong> is currently quarantining and making
          noise.
        </p>
      </div>
    </div>
  </>
);

export default Info;
